import { render, staticRenderFns } from "./production.vue?vue&type=template&id=b8c25bea&scoped=true&"
import script from "./production.vue?vue&type=script&lang=ts&"
export * from "./production.vue?vue&type=script&lang=ts&"
import style0 from "./production.vue?vue&type=style&index=0&id=b8c25bea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c25bea",
  null
  
)

export default component.exports